import store from '../store'
import {
  SET_ERRORS,
  SET_CURRENT_STEP,
  SET_STORY,
  SET_LAST_STEP,
  SET_PREVENT_REDIRECT,
  SET_SHOW_RECORDING_SUCCESS,
  SET_STORY_LOADING,
  RESET_QUIZ,
  SET_QUESTION,
  SET_QUESTION_ANSWER_LIST,
  SET_CURRENT_STREAK,
  ACCOUNT_SET_LEVEL_DONE,
  SET_STORIES_LIST_LOADER,
  SET_STORIES_LIST,
  SET_IS_SUBMIT,
  SET_PINYIN_SETTINGS,
  SET_WORD_DETAIL,
  CHECK_WORD_IS_CLICKED,
  SET_STORY_DIFFICULTY,
  SET_AUDIO_PRONUNCIATION_SETTING,
  SET_WORD_TYPES_OF_CORRECTION,
  SET_STORY_DICTIONARY,
  PATCH_STORY_DICTIONARY_WORD,
  PATCH_STORY_WORD_TYPE,
  CLEAR_STORY_DICTIONARY,
  SET_DICTIONARY_LOADING,
  SET_AUTO_MASTERY_UPDATES,
} from '../types'
import { MemberStepInStory } from '../../utils/constant'
import { wordSimplified } from '../../utils/helperFunction'
import axiosInstance from '../../axios/axiosInstance'
import { apiErrorText } from '../../i18n/apiError'
import {
  CheckStorySubmissionProps,
  GetCurrentStoriesProps,
  GetWordDetailProps,
  PinyinSettings,
  SetStoryDifficultyProps,
  WordClickProps,
  WordContextProps,
  wordDoesNotKnowProps,
  WordDoKnowProps,
} from '../../types/global'
// var tokenize = require("chinese-tokenizer").loadFile('./cedict_ts.u8');

export const getLastStep = async (params: { storyId: string; level: string }) => {
  const res = await axiosInstance.get(`tracking`, { params })
  return res.data
}

// export const getOldWord = async () => {
//   const res: any = await axios.get(`${MAAYOT_API}words/past-new-words`, {
//     headers,
//   })
//   return res?.data
// }

export const getIntro = async (level: string) => {
  if (!level) {
    return Promise.reject('Invalid params')
  }

  try {
    const { data: dataStory } = await axiosInstance.get(`prismic/getIntro?level=${level?.toLowerCase() || ''}`)

    if (dataStory && JSON.stringify(dataStory) !== '{}') {
      const lastStep = await getLastStep({ storyId: dataStory.id, level: level?.toLowerCase() || '' })

      dataStory.storyContent = dataStory.arContentWithTags
      dataStory.storyIntroduction = dataStory.storyIntroduction.replaceAll(/\s/g, ' ')

      dataStory.arSentencesWord11 = dataStory?.arSentencesWord11 ? dataStory.arSentencesWord11 : []
      dataStory.arSentencesWord12 = dataStory?.arSentencesWord12 ? dataStory.arSentencesWord12 : []
      dataStory.arSentencesWord21 = dataStory?.arSentencesWord21 ? dataStory.arSentencesWord21 : []
      dataStory.arSentencesWord22 = dataStory?.arSentencesWord22 ? dataStory.arSentencesWord22 : []

      dataStory.arWordSen11 = dataStory.arSentencesWord11.map((word) => word.word)
      dataStory.arWordSen12 = dataStory.arSentencesWord12.map((word) => word.word)
      dataStory.arWordSen21 = dataStory.arSentencesWord21.map((word) => word.word)
      dataStory.arWordSen22 = dataStory.arSentencesWord22.map((word) => word.word)
      dataStory.arContent = [
        ...dataStory.arContent,
        ...dataStory.arSentencesWord11,
        ...dataStory.arSentencesWord12,
        ...dataStory.arSentencesWord21,
        ...dataStory.arSentencesWord22,
      ]

      // let oldWords
      // if (oldWordRes?.length) {
      //   oldWords = []
      //   oldWordRes.forEach((wordObj) => {
      //     const { data = {} } = wordObj || {}
      //     const { word, level: objLevel } = data || {}
      //     if (objLevel?.toLowerCase() == level.toLowerCase()) {
      //       oldWords.push(word)
      //     }
      //   })
      // }
      // dispatch({
      //   type: SET_STORY,
      //   payload: { ...dataStory, oldWords },
      // })
      store.dispatch({
        type: SET_LAST_STEP,
        payload: lastStep?.data?.[0]?.data?.step,
      })
    } else {
      store.dispatch({
        type: SET_ERRORS,
        payload: 'Story not found',
      })
      return Promise.reject("'Story not found',")
    }
  } catch (error) {
    store.dispatch({
      type: SET_ERRORS,
      payload: 'Story not found',
    })
  }
}

export const getStory = async (id: string, level: string) => {
  if (!id) {
    return Promise.reject('Invalid params')
  }
  // A link straight into a story (the answer page in a story email) has no level in the store yet:
  // the feed is what normally sets it. The API resolves the story from its id alone, so an empty
  // level is fine — without this, those links opened an empty reader.
  const storyLevel = level || ''

  // Clear previous story's dictionary cache
  store.dispatch({ type: CLEAR_STORY_DICTIONARY })

  store.dispatch({
    type: SET_STORY_LOADING,
    payload: { storyLoading: true },
  })

  try {
    const resData = await axiosInstance.get(`prismic/findStory?storyId=${id}&level=${storyLevel.toLowerCase()}`)
    const dataStory = resData.data

    if (dataStory && JSON.stringify(dataStory) !== '{}') {
      const lastStep = await getLastStep({ storyId: dataStory.id, level: level?.toLowerCase() || '' })

      dataStory.englishContent = dataStory.englishContent
      dataStory.storyContent = dataStory.arContentWithTags

      dataStory.arSentencesWord11 = dataStory?.arSentencesWord11 ? dataStory.arSentencesWord11 : []
      dataStory.arSentencesWord12 = dataStory?.arSentencesWord12 ? dataStory.arSentencesWord12 : []
      dataStory.arSentencesWord21 = dataStory?.arSentencesWord21 ? dataStory.arSentencesWord21 : []
      dataStory.arSentencesWord22 = dataStory?.arSentencesWord22 ? dataStory.arSentencesWord22 : []

      dataStory.arWordSen11 = dataStory.arSentencesWord11.map((word) => word.word)
      dataStory.arWordSen12 = dataStory.arSentencesWord12.map((word) => word.word)
      dataStory.arWordSen21 = dataStory.arSentencesWord21.map((word) => word.word)
      dataStory.arWordSen22 = dataStory.arSentencesWord22.map((word) => word.word)
      dataStory.arContent = [
        ...dataStory.arContent,
        ...dataStory.arSentencesWord11,
        ...dataStory.arSentencesWord12,
        ...dataStory.arSentencesWord21,
        ...dataStory.arSentencesWord22,
      ]
      // let oldWords
      // if (oldWordRes?.length) {
      //   oldWords = []
      //   oldWordRes.forEach((wordObj) => {
      //     const { data = {} } = wordObj || {}
      //     const { word, level: objLevel } = data || {}
      //     if (objLevel?.toLowerCase() == level.toLowerCase()) {
      //       oldWords.push(word)
      //     }
      //   })
      // }
      store.dispatch({
        type: SET_STORY,
        payload: { ...dataStory },
      })
      store.dispatch({
        type: SET_LAST_STEP,
        payload: lastStep?.data?.[0]?.data?.step,
      })

      // Preload dictionary for instant word lookup
      preloadStoryDictionary(dataStory.id)

      store.dispatch({
        type: SET_STORY_LOADING,
        payload: { storyLoading: false },
      })
      return { ...dataStory }
    } else {
      store.dispatch({
        type: SET_STORY_LOADING,
        payload: { storyLoading: false },
      })
      store.dispatch({
        type: SET_ERRORS,
        payload: 'Story not found',
      })
      return Promise.reject("'Story not found',")
    }
  } catch (err) {
    store.dispatch({
      type: SET_ERRORS,
      payload: 'Story not found',
    })
    store.dispatch({
      type: SET_STORY,
      payload: null,
    })
    store.dispatch({
      type: SET_STORY_LOADING,
      payload: { storyLoading: false },
    })
    return Promise.reject(err)
  }
}

export const setStep = (step: any) => {
  store.dispatch({
    type: SET_CURRENT_STEP,
    payload: step,
  })
}

export const setShowRecordingSuccess = (show: boolean) => {
  store.dispatch({
    type: SET_SHOW_RECORDING_SUCCESS,
    payload: show,
  })
}

export const resetStory = async (level: string, storyId: string) => {
  if (!level || !storyId) {
    return
  }
  const step = MemberStepInStory.INTRODUCTION
  const content = {
    step,
    level: level?.toLowerCase() || '',
    storyId,
    localDate: new Date().toLocaleDateString('en-CA'), // YYYY-MM-DD in user's timezone
  }

  // Clear dictionary cache on story reset
  store.dispatch({ type: CLEAR_STORY_DICTIONARY })

  store.dispatch({
    type: ACCOUNT_SET_LEVEL_DONE,
    payload: level.toLowerCase() || '',
  })
  store.dispatch({
    type: SET_LAST_STEP,
    payload: step,
  })
  store.dispatch({
    type: SET_STORY,
    payload: {},
  })

  store.dispatch({
    type: RESET_QUIZ,
    payload: {},
  })
  store.dispatch({
    type: SET_QUESTION,
    payload: {
      question: '',
      questionContent: [],
      curAnswer: '',
    },
  })
  store.dispatch({
    type: SET_QUESTION_ANSWER_LIST,
    payload: {
      answers: [],
      cursorRefId: null,
      cursorTs: null,
    },
  })
  store.dispatch({
    type: SET_CURRENT_STREAK,
    payload: null,
  })
  try {
    const res = await axiosInstance.post(`tracking`, content)
    return res
  } catch (error) {
    return null
  }
}

//post Current Step
export const saveLastStep = (step: string, level: string, storyId: string) => {
  if (!level || !storyId || !step) {
    return
  }
  const content = {
    step,
    level: level?.toLowerCase() || '',
    storyId,
    localDate: new Date().toLocaleDateString('en-CA'), // YYYY-MM-DD in user's timezone
  }
  store.dispatch({
    type: SET_LAST_STEP,
    payload: step,
  })
  return axiosInstance.post(`tracking`, content)
  // .then((resData) => resData.json())
  // .then((data) => {
  //   console.log("save step done")
  // })
  // .catch(e => {
  //   console.error(e)
  // })
}

export const setPreventRedirect = (isPrevent: true) => {
  store.dispatch({
    type: SET_PREVENT_REDIRECT,
    payload: isPrevent,
  })
}

export const submitRecording = async (id: string, memberName: string, uploadKey: string, level: string) => {
  const content = {
    memberName,
    storyId: id,
    recordingUrl: uploadKey,
    level,
  }

  try {
    const res = await axiosInstance.post(`story-listening/recording`, content)
    const data = res?.data

    if (data && !data.status && Object.keys(data) && Object.keys(data).length > 0) {
      return data
    } else {
      store.dispatch({
        type: SET_ERRORS,
        payload: apiErrorText(data) || data?.message?.message,
      })
      return Promise.reject(apiErrorText(data) || data?.message?.message)
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getStories = async ({ level, plan }: GetCurrentStoriesProps) => {
  try {
    store.dispatch({ type: SET_STORIES_LIST_LOADER, payload: true })
    const res = await axiosInstance.get(`prismic/getIntroDB?level=${level?.toLowerCase() || ''}&plan=${plan}`)
    store.dispatch({ type: SET_STORIES_LIST, payload: res?.data })
    store.dispatch({ type: SET_PINYIN_SETTINGS, payload: res?.data?.pinyin_setting })
    store.dispatch({ type: SET_STORY_DIFFICULTY, payload: res?.data?.difficulty_level })
    store.dispatch({ type: SET_AUDIO_PRONUNCIATION_SETTING, payload: res?.data?.audio_pronunciation_setting || 'both' })
    store.dispatch({ type: SET_AUTO_MASTERY_UPDATES, payload: res?.data?.auto_mastery_updates !== false })
    store.dispatch({ type: SET_STORIES_LIST_LOADER, payload: false })
    return res?.data
  } catch (error) {
    store.dispatch({ type: SET_STORIES_LIST_LOADER, payload: false })
  }
}

export const checkStorySubmission = async (data: CheckStorySubmissionProps) => {
  try {
    const res = await axiosInstance.post(`story-listening/check-story-submission`, data)
    store.dispatch({ type: SET_IS_SUBMIT, payload: res?.data })
    return res?.data
  } catch (error) {
    console.log('error', error)
  }
}

export const wordDoesNotKnow = async (payload: wordDoesNotKnowProps) => {
  const data: any = {
    ...payload,
  }
  delete data.page

  try {
    const res = await axiosInstance.post(`words/update-clicked-word`, data)

    store.dispatch({ type: CHECK_WORD_IS_CLICKED, payload: false })
    if (payload?.page === 'correction') {
      store.dispatch({ type: SET_WORD_TYPES_OF_CORRECTION, payload: res?.data })
    }
    if (payload?.page === 'story') {
      // Patch only the interacted word's mastery bucket instead of replacing every
      // array. Overwriting the whole set repainted all underlines from one tap and
      // could wipe them en masse when the displayed arrays were stale.
      patchCurrentStoryWordType(res?.data?.clickedWord)
    }
    syncClickedWordMastery(res?.data?.clickedWord)
    return res?.data
  } catch (error) {
    // store.dispatch({
    //   type: SET_ERRORS,
    //   payload: 'something went wrong',
    // })
    console.log('error', error)
  }
}

export const wordDoKnow = async (data: WordDoKnowProps) => {
  try {
    const res = await axiosInstance.post(`words/update-not-clicked-words`, data)

    return res?.data
  } catch (error) {
    store.dispatch({
      type: SET_ERRORS,
      payload: 'something went wrong',
    })
  }
}

export const loadWordExamples = async (wordData: any) => {
  try {
    const payload = {
      word: wordData.word,
      pinyin: wordData.pinyin,
      english: wordData.english,
      sentenceString: wordData.sentenceString,
      storyId: wordData.storyId || localStorage.getItem('storyId'),
      level: wordData.level || localStorage.getItem('level'),
    }

    const res = await axiosInstance.post(`words/get-clicked-word`, payload)

    // Update the current word detail with examples
    const currentState = store.getState()
    const currentWordDetail = currentState.story.wordDetails?.detail

    if (currentWordDetail?.word === res.data.word) {
      const updatedWordDetail = {
        ...currentWordDetail,
        sentence: res.data.sentence || [],
      }

      store.dispatch({
        type: SET_WORD_DETAIL,
        payload: {
          loader: false,
          detail: updatedWordDetail,
        },
      })
    }

    return res.data.sentence || []
  } catch (error) {
    return []
  }
}

export const getWordDetail = async (data: GetWordDetailProps) => {
  try {
    // Check cache first for instant word lookup
    const state = store.getState()
    const cachedWord = state.story.storyDictionary?.[data?.detail?.word]

    if (cachedWord) {
      // Instant response from cache (without examples)
      const wordDetail = {
        ...cachedWord,
        type: data?.wordType,
        sentenceString: data?.detail?.sentenceString,
        sentenceWords: data?.detail?.sentenceWords,
        // Examples will be loaded on-demand when View Examples is clicked
        sentence: undefined,
      }

      store.dispatch({
        type: SET_WORD_DETAIL,
        payload: { loader: false, detail: wordDetail },
      })

      store.dispatch({ type: CHECK_WORD_IS_CLICKED, payload: false })
      return cachedWord
    }

    // Fallback to existing individual API call
    store.dispatch({ type: SET_WORD_DETAIL, payload: { loader: true, detail: data?.detail } })
    const res = await axiosInstance.post(`words/get-clicked-word`, data?.payload)
    const wordDetail = {
      _id: res?.data?._id,
      word: data?.detail?.word || res?.data?.word,
      pinyin: data?.detail?.pinyin || res?.data?.pinyin,
      english: data?.detail?.english || res?.data?.english,
      // The learner-language gloss (docs/plans/localization.md, "API overlay"), null when missing.
      localizedMeaning: res?.data?.localizedMeaning ?? null,
      meaningLanguage: res?.data?.meaningLanguage ?? null,
      // The sense inventory ([{ pinyin, en }]), null until the word has one; localizedMeaning
      // split on '; ' is aligned with it.
      senses: res?.data?.senses ?? null,
      type: data?.wordType,
      importance: res?.data?.importance,
      mastery: res?.data?.mastery,
      struggling: res?.data?.struggling,
      lookups: res?.data?.lookups,
      last_seen: res?.data?.last_seen,
      // The raw time behind last_seen, formatted in the interface language by the word panel.
      last_seen_at: res?.data?.last_seen_at ?? null,
      test_level: res?.data?.test_level,
      frequency: res?.data?.frequency,
      has_audio: res?.data?.has_audio,
      sentence: res?.data?.sentence,
      sentenceString: data?.detail?.sentenceString,
      sentenceWords: data?.detail?.sentenceWords,
    }
    store.dispatch({
      type: SET_WORD_DETAIL,
      payload: { loader: false, detail: wordDetail },
    })

    store.dispatch({ type: CHECK_WORD_IS_CLICKED, payload: false })
    return res?.data
  } catch (error) {
    store.dispatch({ type: SET_WORD_DETAIL, payload: { loader: false, detail: { ...data?.detail } } })
    // store.dispatch({
    //   type: SET_ERRORS,
    //   payload: 'something went wrong',
    // })
  }
}

// Saves without touching the store: the reader settings apply the change
// before the request and roll it back if this rejects.
export const savePinyinSettings = async (data: PinyinSettings) => {
  await axiosInstance.patch(`user-language/pinyin/update-user-pinyin-setting`, data)
}

export const wordClick = async (data: WordClickProps) => {
  try {
    const res = await axiosInstance.post(`words/change-clicked-word-status`, data)
    store.dispatch({ type: CHECK_WORD_IS_CLICKED, payload: true })
    // Patch only the interacted word's mastery bucket instead of replacing every array.
    patchCurrentStoryWordType(res?.data?.clickedWord)
    syncClickedWordMastery(res?.data?.clickedWord)
    return res?.data
  } catch (err) {
    console.log('wordClick api call fail')
  }
}

// Move only the interacted word into its new mastery bucket on the current story,
// leaving every other word's highlight untouched. This replaces the previous
// whole-array overwrite, which repainted (and could wipe) every underline from a
// single tap. No-op when the server returned no clickedWord (e.g. auto-mastery off).
const patchCurrentStoryWordType = (clickedWord: { word: string; mastery: string; next_review_days?: number | null } | null | undefined) => {
  if (!clickedWord?.word || !clickedWord?.mastery) return
  store.dispatch({
    type: PATCH_STORY_WORD_TYPE,
    payload: { word: clickedWord.word, mastery: clickedWord.mastery },
  })
}

// Keep the in-memory dictionary cache and the open word detail in sync with the
// server's latest mastery for the clicked word. Without this the sidebar would
// keep showing the stale value cached at story-load time (see bug report).
const syncClickedWordMastery = (
  clickedWord:
    | { word: string; mastery: string; next_review_days: number | null; struggling?: boolean; lookups?: number }
    | null
    | undefined,
) => {
  if (!clickedWord?.word || !clickedWord?.mastery) return
  const patch: any = { mastery: clickedWord.mastery }
  if (clickedWord.next_review_days !== undefined) patch.next_review_days = clickedWord.next_review_days
  // The server recomputes the struggling flag on every lookup / mastery change,
  // so carry it through — otherwise the badge lingers after "Mark as mastered"
  // and only appears on the next story load once a word tips over the threshold.
  if (clickedWord.struggling !== undefined) patch.struggling = clickedWord.struggling
  if (clickedWord.lookups !== undefined) patch.lookups = clickedWord.lookups
  store.dispatch({
    type: PATCH_STORY_DICTIONARY_WORD,
    payload: { word: clickedWord.word, patch },
  })
  const openDetail = store.getState().story.wordDetails
  if (openDetail?.word && wordSimplified(openDetail.word) === clickedWord.word) {
    store.dispatch({
      type: SET_WORD_DETAIL,
      payload: { loader: false, detail: { ...openDetail, ...patch } },
    })
  }
}

export const wordContext = async (data: WordContextProps) => {
  try {
    const res = await axiosInstance.post(`words/get-word-context`, data)

    return res?.data
  } catch (err) {
    console.log('wordContext api call fail')
  }
}

export const setStoryDifficulty = async ({ data }: SetStoryDifficultyProps) => {
  try {
    const res = await axiosInstance.patch(`user-language/user/update-user-story-difficulty-setting`, data)
    store.dispatch({ type: SET_STORY_DIFFICULTY, payload: res?.data?.data?.difficulty_level })
    return res?.data
  } catch (err) {
    console.log('setStoryDifficulty api call fail')
  }
}

export type AudioPronunciationSetting = 'both' | 'female_only' | 'male_only' | 'none'

export const updateAudioPronunciationSetting = async (setting: AudioPronunciationSetting) => {
  try {
    const res = await axiosInstance.patch(`user-language/audio/update-audio-pronunciation-setting`, {
      audio_pronunciation_setting: setting,
    })
    store.dispatch({ type: SET_AUDIO_PRONUNCIATION_SETTING, payload: res?.data?.data?.audio_pronunciation_setting })
    return res?.data
  } catch (err) {
    console.log('updateAudioPronunciationSetting api call fail')
  }
}

export const preloadStoryDictionary = async (storyId: string) => {
  try {
    store.dispatch({ type: SET_DICTIONARY_LOADING, payload: true })

    const res = await axiosInstance.post('words/story-words-bulk', {
      storyId,
    })

    // Transform array to key-value map for fast lookup
    const dictionaryMap = res.data.reduce((acc: any, word: any) => {
      acc[word.word] = word
      return acc
    }, {})

    store.dispatch({ type: SET_STORY_DICTIONARY, payload: dictionaryMap })
  } catch (error: any) {
    // Silent fallback - no user notification
    store.dispatch({ type: SET_DICTIONARY_LOADING, payload: false })
  }
}
